import { service } from '@maia/customer';
import { showToast } from '@maia/ui';
import { useMutation, useQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import Cookies from 'js-cookie';
import { getCustomerOptions } from './../../../../../features/customer/customer/queryOptions';
import { EditContactForm } from './../../../../../features/edit-customer/contact-form';
import { queryClient } from './../../../../../main';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/edit/_layout/contact',
)({
  component: RouteComponent,
  loader: ({ context: { queryClient }, params: { guid } }) =>
    queryClient.ensureQueryData(getCustomerOptions(guid)),
});

function RouteComponent() {
  const params = Route.useParams();
  const { data } = useQuery(getCustomerOptions(params.guid));
  const navigate = useNavigate();

  const { mutateAsync: updateDetails, isPending } = useMutation({
    mutationFn: (body: Parameters<typeof service.updateDetails>[number]) =>
      service.updateDetails(body),
    onSuccess: (response) => {
      showToast({
        intent: 'success',
        title: 'De contact gegevens zijn veranderd!',
        config: { position: 'top-right' },
      });

      queryClient.invalidateQueries({
        queryKey: ['customers', 'customer', params.guid],
      });

      if (response.response?.token) {
        Cookies.set('auth_tokens', JSON.stringify(response.response.token), {
          secure: true,
          sameSite: 'strict',
          expires: new Date(response.response.token.refreshTokenExpiresAt),
        });
      }
      navigate({ to: `/customers/$guid`, params: { guid: params.guid } });
    },
    onError: () => {
      showToast({
        intent: 'error',
        title: 'Er ging iets mis',
        description:
          'We konden de contact gegevens niet veranderen. Probeer het later opnieuw',
        config: { position: 'top-right' },
      });
    },
  });

  return (
    <div className="area-page-content content-grid max-form-width">
      {data && <EditContactForm customer={data} isPending={isPending} onSubmit={updateDetails} />}
    </div>
  );
}
